(function () {
  'use strict';

  var button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  var threshold = 360;
  var scheduled = false;

  function updateVisibility() {
    button.classList.toggle('is-visible', window.scrollY > threshold);
    scheduled = false;
  }

  window.addEventListener('scroll', function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateVisibility);
  }, { passive: true });

  button.addEventListener('click', function () {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
  });

  updateVisibility();
}());
